import React, { useState } from 'react';
import { IUserJson } from '@scale/shared/types/user';
import TaskerScreeningGrading from './TaskerScreeningGrading';
import TaskerScreeningCorpSettings from './TaskerScreeningCorpSettings';
import TaskerScreeningBenchmarks from './TaskerScreeningBenchmarks';
import TaskerScreeningAuditorEvaluation from './TaskerScreeningAuditorEvaluation';
import TaskerScreeningAuditorExplain from './TaskerScreeningAuditorExplain';
import { Tabs, Button } from '@scale/scaleui';
import { enumValues } from '@scale/shared/utils';
import TaskerScreeningAuditorPermissions from 'react-scale/corp/views/rapid/TaskerScreeningUtils/TaskerScreeningAuditorPermissions';
import TaskerScreeningPurgeScreenings from 'react-scale/corp/views/rapid/TaskerScreeningUtils/TaskerScreeningPurgeScreenings';

interface TaskerScreeningUtilsProps {
  user: IUserJson;
}

enum TaskerScreeningUtilsTab {
  Grading = 'Grading',
  AuditorPermissions = 'Auditor Permissions',
  AuditorExplain = 'Auditor Explain',
  ScreeningBenchmarks = 'Screening Benchmarks',
  AuditorEvaluation = 'Auditor Evaluation',
  CorpSettings = 'Instructions Settings',
  PurgeScreenings = 'Purge Screenings',
}

const DOCUMENTATION_LINK =
  'https://scale.atlassian.net/wiki/spaces/OP/pages/443252738/Next+Generation+Screening';
export const AUDITOR_DOCUMENTATION_LINK =
  'https://scale.atlassian.net/wiki/spaces/OP/pages/450134017/Next+Generation+Screening+Auditor';

const TaskerScreeningUtils: React.FC<TaskerScreeningUtilsProps> = ({ user }) => {
  const [currentTab, setCurrentTab] = useState<string>(TaskerScreeningUtilsTab.AuditorPermissions);

  const tabToComponent: Record<TaskerScreeningUtilsTab, React.ReactNode> = {
    [TaskerScreeningUtilsTab.Grading]: <TaskerScreeningGrading user={user} isCorp />,
    [TaskerScreeningUtilsTab.AuditorPermissions]: <TaskerScreeningAuditorPermissions user={user} />,
    [TaskerScreeningUtilsTab.AuditorExplain]: <TaskerScreeningAuditorExplain user={user} />,
    [TaskerScreeningUtilsTab.ScreeningBenchmarks]: <TaskerScreeningBenchmarks user={user} />,
    [TaskerScreeningUtilsTab.AuditorEvaluation]: <TaskerScreeningAuditorEvaluation user={user} />,
    [TaskerScreeningUtilsTab.CorpSettings]: <TaskerScreeningCorpSettings user={user} />,
    [TaskerScreeningUtilsTab.PurgeScreenings]: <TaskerScreeningPurgeScreenings user={user} />,
  };

  return (
    <div>
      <div className="scaleui scale-theme scale-tailwind mb-4 flex flex-row">
        <Tabs
          className="mr-auto"
          tabs={enumValues(TaskerScreeningUtilsTab).map(id => ({ id }))}
          value={currentTab}
          onChange={setCurrentTab}
        />
        <Button
          variant="primary"
          onClick={() => {
            window.open(DOCUMENTATION_LINK, '_blank');
          }}
        >
          Open Documentation
        </Button>
      </div>
      {tabToComponent[currentTab as TaskerScreeningUtilsTab]}
    </div>
  );
};

export default TaskerScreeningUtils;
